module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page-msgbox"
  }, [_c('h1', {
    staticClass: "page-title"
  }, [_vm._v("Message Box")]), _vm._v(" "), _c('div', {
    staticClass: "page-msgbox-wrapper"
  }, [_c('mt-button', {
    attrs: {
      "size": "large"
    },
    nativeOn: {
      "click": function($event) {
        _vm.openAlert($event)
      }
    }
  }, [_vm._v("打开 alert 提示框")]), _vm._v(" "), _c('mt-button', {
    attrs: {
      "size": "large"
    },
    nativeOn: {
      "click": function($event) {
        _vm.openConfirm($event)
      }
    }
  }, [_vm._v("打开 confirm 提示框")]), _vm._v(" "), _c('mt-button', {
    attrs: {
      "size": "large"
    },
    nativeOn: {
      "click": function($event) {
        _vm.openPrompt($event)
      }
    }
  }, [_vm._v("打开 prompt 提示框")])], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-e163d8f2"}!./~/vue-loader/lib/selector.js?type=template&index=0!./example/pages/message-box.vue
// module id = 324
// module chunks = 0